"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const dullnessskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-dullnessskin` : '') + (description ? ` desc-dullnessskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-dullnessskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-dullnessskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.4 16.7a1.1 1.1 0 1 1 0 2.18 1.1 1.1 0 0 1 0-2.18Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.2 16.7a1.1 1.1 0 1 1 0 2.18 1.1 1.1 0 0 1 0-2.18Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.7 16.7a1.1 1.1 0 1 1 0 2.18 1.1 1.1 0 0 1 0-2.18Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.48 16.7a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.39 12.95a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.92 12.95a1.1 1.1 0 1 1 0 2.18 1.1 1.1 0 0 1 0-2.18Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.45 12.95a1.1 1.1 0 1 1 0 2.18 1.1 1.1 0 0 1 0-2.18Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.16 8.14a.75.75 0 0 1 0 1.5H.84a.75.75 0 0 1 0-1.5h22.32Z",
    fill: "#232323"
  }));
};
var _default = exports.default = dullnessskin;